import axios from 'axios';

export const OverlayApi = {
  createNewSession: async (data = {}) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/conversation/new-session`,
        data,
        {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      return response;
    } catch (error) {
      console.error(
        'Error creating session:',
        error.response?.data || error.message
      );
      throw error;
    }
  },

  submitFeedback: async (rating, submitFeedback) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/submit-feedback`,
        {
          ratings: rating,
          feedback_text: submitFeedback,
        },
        {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      return response;
    } catch (error) {
      console.error(
        'Error submitting feedback:',
        error.response?.data || error.message
      );
      throw error;
    }
  },

  getAllConversations: async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/conversation/listall`,
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching conversations:', error);
      throw error;
    }
  },

  updateConversation: async (conversation_id, payload) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/conversation/${conversation_id}`,
        payload,
        {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      console.log('response from patch api', response);
      return response;
    } catch (error) {
      console.error('Error updating the conversation', error);
      throw error;
    }
  },

  deleteOne: async (conversation_id) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/delete-conversation/${conversation_id}`,
        {
          withCredentials: true,
        }
      );
      console.log('response after deleting one conversation', response);
      return response;
    } catch (error) {
      console.error('error while deleting the conversation', error);
      throw error;
    }
  },
  fetchConversation: async (conversation_id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/conversation/${conversation_id}`,
        {
          withCredentials: true,
        }
      );

      return response;
    } catch (error) {
      console.error('error loading the conversation', error);
      throw error;
    }
  },
};
